import { requireNativeViewManager } from 'expo-modules-core';
import * as React from 'react';

import { ReactNativeDetectNotePitchViewProps } from './ReactNativeDetectNotePitch.types';

const NativeView: React.ComponentType<ReactNativeDetectNotePitchViewProps> =
  requireNativeViewManager('ReactNativeDetectNotePitch');

export default function ReactNativeDetectNotePitchView(props: ReactNativeDetectNotePitchViewProps) {
  return <NativeView {...props} />;
}
